window.HelpNavigation = ImageList.extend({
    handleActionButtonClick: function() {
        var bookmarkPageID = this.app.getComponent("Storage").getItem("bookmark");
        if (bookmarkPageID != "-1") {
            this.app.router.navigate("#page/" + bookmarkPageID, {
                trigger: true
            });
        } else {
            this.app.router.navigate("#slide/010_010", {
                trigger: true
            });
        }
    },

    getData: function($xml, language) {
        var data = ImageList.prototype.getData.call(this, $xml, language);
        data.buttonLabel = LanguageManager.getString("close");
        return data;
    }
});
